import React, { createContext, useContext, useEffect, useState } from "react";
import { useSettings } from "./SettingsContext";

const CurrencyContext = createContext({ currency: "JMD", setCurrency: () => {} });

export const CurrencyProvider = ({ children }) => {
  const { exchangeRate } = useSettings();
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("c4t_currency") || "JMD");

  useEffect(() => { localStorage.setItem("c4t_currency", currency); }, [currency]);

  const setCurrency = (c) => setCurrencyState(c);
  const toggle = () => setCurrencyState(c => (c === "USD" ? "JMD" : "USD"));

  // All prices are stored and passed as JMD.
  // USD mode is display-only: divide by exchange rate for a rough USD equivalent.
  // The second arg (_ignored) is kept for backward compatibility only.
  const format = (price, _ignored) => {
    const jmd = Number(price || 0);
    if (currency === "USD") {
      const rate = exchangeRate || 160;
      return `$${(jmd / rate).toFixed(2)}`;
    }
    return `J$${Math.round(jmd).toLocaleString()}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggle, exchangeRate, format }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
